export const isFetching = state => state.formsV2.submissions.fetching;
export const isSaving = state => state.formsV2.submissions.saving;
export const submissions = state => state.formsV2.submissions.list;
